import { useState } from 'react';
import { OrganizationUserType } from '@/bundle/_Opco/types/types';
import { Drawer } from '@/components/Drawer/Drawer';
import { Box } from '@/components/Box/Box';
import { EditPersonalDetailsForm } from '@/bundle/_Opco/ui/OrganizationDetails/Details/ui/OrganizationUserPersonalDetails/EditPersonalDetailsForm';
import { isInvitedOrganizationUser } from '@/helpers/organizationHelpers';
import { UserPersonalDetails } from '@/bundle/shared/components/UserDetails/UserPersonalDetails';

type OrganizationUserPersonalDetailsType = {
  user: OrganizationUserType;
  onSave: () => void;
};

export const OrganizationUserPersonalDetails = ({ user, onSave }: OrganizationUserPersonalDetailsType) => {
  const [isEditOpen, setIsEditOpen] = useState(false);

  const { first_name, middle_name, last_name, status } = user;

  const openEdit = () => setIsEditOpen(true);

  const closeEdit = () => setIsEditOpen(false);

  const onSuccess = () => {
    onSave();
    closeEdit();
  };

  const isInvited = isInvitedOrganizationUser(status);
  const personalDetails = {
    first_name,
    middle_name,
    last_name,
  };

  return (
    <Box width='100%'>
      <UserPersonalDetails isEdit={isInvited} personalDetails={personalDetails} onEditOpen={openEdit} />
      <Drawer
        isOpen={isEditOpen}
        onClose={closeEdit}
        header='Edit Personal Information'
        subHeader='Please edit personal information.'
      >
        <EditPersonalDetailsForm user={user} onClose={closeEdit} onSuccess={onSuccess} />
      </Drawer>
    </Box>
  );
};
